export default __webpack_public_path__ + "static/media/RelWhit.86dce53b.svg";